/**
 * Default guest Express / Get Started bar description.
 * Restored from PostHog experiment 487378 (credentials / NCCA copy).
 */
export const GET_STARTED_BAR_GUEST_DESCRIPTION =
	"4 advanced credentials, 200+ courses, NCCA-accredited CPT exam study plan, and more...";
